export const DEFAULT_INSTRUCTIONS = `Devuelve un SOLO array de 11 posiciones en este orden exacto:
  [
    "Fecha de factura",
    "Numero de factura",
    "CIF emisor",
    "Nombre emisor",
    "CIF cliente",
    "Nombre cliente",
    Base imponible,
    % iva,
    Importe iva,
    Total,
    [[Numero de linea, "Descripción", Cantidad, Precio, % descuento, Importe linea],
    [Numero de linea, "Descripción", Cantidad, Precio, % descuento, Importe linea]]
  ]`;

export const DEFAULT_TEMPLATE = {
  "Fecha de factura": "",
  "Numero de factura": "",
  "CIF emisor": "",
  "Nombre emisor": "",
  "CIF cliente": "",
  "Nombre cliente": "",
  "Base imponible": 0,
  "% iva": 0,
  "Importe iva": 0,
  "Total": 0,
  "Lineas de factura": [
    {
      "Numero de linea": "",
      "Descripción": "",
      "Cantidad": 0,
      "Precio": 0,
      "% descuento": 0,
      "Importe linea": 0,
    },
  ],
};
